export default __webpack_public_path__ + "static/media/employee-tracker.60502b5e.png";